import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { youtubeVideos } from '../../src/seed';
export function YouTubeLibrary() {
  const navigate = useNavigate();
  const formatDuration = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, '0')}`;
  };
  const formatDate = (isoString: string) => {
    return new Date(isoString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  return <div className="space-y-6" data-id="element-817">
      <div data-id="element-818">
        <h1 className="text-3xl font-bold tracking-tight" data-id="element-819">Library</h1>
        <p className="text-muted-foreground" data-id="element-820">
          All saved videos across all collections
        </p>
      </div>

      <div className="space-y-3" data-id="element-821">
        {youtubeVideos.map(video => <Card key={video.id} className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate(`/youtube/library/${video.id}`)} data-id="element-822">
            <CardContent className="p-4 flex items-center gap-4" data-id="element-823">
              <div className="w-32 aspect-video bg-muted rounded-md shrink-0" data-id="element-824" />
              <div className="flex-1 min-w-0" data-id="element-825">
                <h3 className="font-semibold text-lg truncate mb-1" data-id="element-826">
                  {video.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-2" data-id="element-827">
                  {video.channel} · {formatDuration(video.duration)} ·{' '}
                  {formatDate(video.published)}
                </p>
                <div className="flex gap-2" data-id="element-828">
                  {video.hasTranscript && <Badge variant="secondary" className="text-xs" data-id="element-829">
                      Transcribed
                    </Badge>}
                  {video.questionCount > 0 && <Badge variant="secondary" className="text-xs" data-id="element-830">
                      {video.questionCount} Questions generated
                    </Badge>}
                </div>
              </div>
            </CardContent>
          </Card>)}
      </div>
    </div>;
}